import { Plus as AddIcon } from "lucide-react";
import { Helmet } from "react-helmet";

import { OrganisationsType } from "api/organisations/types";
import PageLayout from "components/layouts/PageLayout";
import { hasPermissions } from "components/stores/UserStore";
import UltimateButton from "components/UltimateButton";
import { useModal } from "utils/hooks/useModal";

import OrganisationsTable from "./OrganisationsTable";
import NewOrganisationModal from "./OrganisationsTable/components/NewOrganisationModal";
import { useOrganisationsFilter } from "./OrganisationsTable/useOrganisationsFilter";

const OrganisationPage = () => {
  const { filters, searchField } = useOrganisationsFilter();
  const { isOpen, handleClose, handleOpen } = useModal<OrganisationsType>();

  return (
    <>
      <Helmet title="Lendzee | Organisations Management" />
      <PageLayout
        title="Organisations List"
        subtitle="Manage organisations, partners and their settings."
        search={{
          value: searchField.value,
          onChange: searchField.onChange,
          placeholder: "Search by organisation name",
        }}
        actions={
          hasPermissions("write:organisations") ? (
            <UltimateButton
              text="Add Organisation"
              Icon={
                AddIcon as React.ComponentType<{
                  size?: number;
                  className?: string;
                  style?: React.CSSProperties;
                }>
              }
              sx={{ py: 1 }}
              onClick={() => handleOpen()}
            />
          ) : undefined
        }
      >
        <OrganisationsTable filters={filters} />
      </PageLayout>
      {hasPermissions("write:organisations") && (
        <NewOrganisationModal isOpen={isOpen} handleClose={handleClose} />
      )}
    </>
  );
};

export default OrganisationPage;
